import * as React from 'react';
import { Form_EnumInputProps } from '../../../../../../react-commons/components/form/inputs/Form_EnumInput';
import { Inputs } from '../../../../../../react-commons/utils/form/inputs';
import { getEnumFormatter } from '../../../../resource/enumerations/utils/getEnumFormatter';
import { usePropertyInfo } from '../../../hooks/usePropertyInfo';
import { PropertyValidationInformation } from '../../../util/PropertyValidationInformation';

export const Form_PropertyEnumInput = <T extends object, N extends boolean, E extends string>({
    labelOverride,
    propertyValidationInformation: { propertyIdentifier, resourceType, resourceId },
    hideLabel,
    readOnly,
    ...props
}: Omit<Form_EnumInputProps<T, N, E>, 'label' | 'labelInfo' | 'severity' | 'helperText' | 'children' | 'enumFormatter'> & {
    labelOverride?: string;
    propertyValidationInformation: PropertyValidationInformation;
    hideLabel?: boolean;
}) => {
    const propertyInfo = usePropertyInfo({
        propertyIdentifier,
        resourceType,
        resourceId,
        hideLabel,
        labelOverride,
        readOnly,
    });

    const enumFormatter = getEnumFormatter(props.enumType);

    return (
        <Inputs.Enum
            enumFormatter={enumFormatter}
            {...propertyInfo}
            {...props}
            helperText={propertyInfo.helperText ? [propertyInfo.helperText] : undefined}
        />
    );
};
